/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetApplicationHealth$Params {}

export function getApplicationHealth(
  http: HttpClient,
  rootUrl: string,
  params?: GetApplicationHealth$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<{
    [key: string]: string;
  }>
> {
  const rb = new RequestBuilder(rootUrl, getApplicationHealth.PATH, "get");
  if (params) {
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
        [key: string]: string;
      }>;
    }),
  );
}

getApplicationHealth.PATH = "/stats/health";
